import { c as _c } from "react/compiler-runtime";
// Выбор категории для позиции загрузки: только конечные узлы дерева v2 —
// туда сервис каталога и кладёт товар. Если модель поставила категорию,
// которой в дереве нет (старый id), она остаётся в списке с пометкой.
import { useCategories } from "@/api/hooks/use-categories";
import { Select } from "@/components/ui/select";
import { buildCategoryTree, leafTargets } from "@/lib/category-tree";
export function useCategoryLeaves() {
  const $ = _c(7);
  const categories = useCategories().data ?? [];
  const tree = buildCategoryTree(categories);
  const leaves = leafTargets(tree).map(_temp);
  const roots = tree.active.filter(_temp2).map(_temp3);
  let t0;
  if ($[0] !== tree) {
    t0 = (id, fallback) => id ? tree.byId.get(id)?.path.join(" / ") ?? fallback ?? id : fallback ?? "";
    $[0] = tree;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const pathOf = t0;
  const t1 = categories.length === 0;
  let t2;
  if ($[2] !== leaves || $[3] !== pathOf || $[4] !== roots || $[5] !== t1) {
    t2 = {
      leaves,
      roots,
      pathOf,
      loading: t1
    };
    $[2] = leaves;
    $[3] = pathOf;
    $[4] = roots;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp3(row_1) {
  return row_1.category.name;
}
function _temp2(row_0) {
  return row_0.depth === 1;
}
function _temp(row) {
  return {
    id: row.category.id,
    path: row.path.join(" / ")
  };
}
export function CategorySelect(t0) {
  const $ = _c(23);
  const {
    value,
    fallbackPath,
    onChange,
    id,
    className,
    emptyLabel: t1,
    "aria-label": ariaLabel
  } = t0;
  const emptyLabel = t1 === undefined ? "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u0430" : t1;
  const {
    leaves
  } = useCategoryLeaves();
  let t2;
  if ($[0] !== leaves || $[1] !== value) {
    t2 = !value || leaves.some(leaf => leaf.id === value);
    $[0] = leaves;
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const known = t2;
  const t3 = value ?? "";
  let t4;
  if ($[3] !== leaves || $[4] !== onChange) {
    t4 = e => {
      const next = e.target.value || null;
      onChange(next, next ? leaves.find(leaf_0 => leaf_0.id === next)?.path : undefined);
    };
    $[3] = leaves;
    $[4] = onChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== emptyLabel) {
    t5 = <option value="">{emptyLabel}</option>;
    $[6] = emptyLabel;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== fallbackPath || $[9] !== known || $[10] !== value) {
    t6 = !known && value && <option value={value}>{fallbackPath ?? value} (нет в дереве)</option>;
    $[8] = fallbackPath;
    $[9] = known;
    $[10] = value;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== leaves) {
    t7 = leaves.map(_temp4);
    $[12] = leaves;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== ariaLabel || $[15] !== className || $[16] !== id || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <Select id={id} aria-label={ariaLabel} value={t3} className={className} onChange={t4}>{t5}{t6}{t7}</Select>;
    $[14] = ariaLabel;
    $[15] = className;
    $[16] = id;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
function _temp4(leaf_1) {
  return <option key={leaf_1.id} value={leaf_1.id}>{leaf_1.path}</option>;
}